// Belongs to Interview Round Entity
export const InterviewRoundTypeEnum = Object.freeze({
  HR: 0,
  Technical: 1,
  Manager: 2,
  Practical: 3,
  CultureFit: 4,
});

export const InterviewRoundTypeLabel = Object.freeze({
  [InterviewRoundTypeEnum.HR]: "HR",
  [InterviewRoundTypeEnum.Technical]: "Technical",
  [InterviewRoundTypeEnum.Manager]: "Manager",
  [InterviewRoundTypeEnum.Practical]: "Practical",
  [InterviewRoundTypeEnum.CultureFit]: "Culture Fit",
});